import React from 'react';
import PropTypes from 'prop-types';

const CsvExport = ({
  rows,
  columns,
  columnVisibility,
  filename = 'table_data.csv',
}) => {
  const excludedColumns = [
    'nominationId',
    'id',
    'nominationStatusTypeId',
    'actions',
    'createdAt',
    'updatedAt',
    'publishedAt',
  ];

  const visibleColumns = columns.filter(
    (col) =>
      columnVisibility[col.id] !== false && !excludedColumns.includes(col.id),
  );

  const exportToCSV = () => {
    if (!rows.length || !visibleColumns.length) return;

    const headers = visibleColumns.map((col) => col.header);
    const csvRows = [headers];

    rows.forEach((row) => {
      const csvRow = [];
      visibleColumns.forEach((col) => {
        const key = col.accessorKey || col.id;
        const cellValue = row?.original?.[key] || '';
        csvRow.push(cellValue);
      });
      csvRows.push(csvRow);
    });

    const csvContent = csvRows
      .map((row) =>
        row
          .map((cell) => {
            const cellStr = String(cell || '');
            const safeCell = /^[=\-+@]/.test(cellStr) ? `'${cellStr}` : cellStr;
            const escapedCell = safeCell.replace(/"/g, '""');
            return `"${escapedCell}"`;
          })
          .join(','),
      )
      .join('\n');

    const BOM = '\uFEFF';
    const csvWithBOM = BOM + csvContent;

    const blob = new Blob([csvWithBOM], {
      type: 'text/csv;charset=utf-8',
    });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.click();
    window.URL.revokeObjectURL(url);
  };

  return (
    <button
      onClick={exportToCSV}
      className="btn btn-outline-primary w-100"
      type="button"
    >
      <i className="bi bi-file-earmark-arrow-down me-2" /> Export Data
    </button>
  );
};

CsvExport.propTypes = {
  rows: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  columnVisibility: PropTypes.object.isRequired,
  filename: PropTypes.string,
};

export default CsvExport;
